import SMMarketsAcknowledge from '../components/board/customForms/smmarkets/SMMarketsAcknowledge'
import VowellsInformationForm from '../components/board/customForms/vowells/VowellsInformationForm'
import VowellsInformationOnline from '../components/board/customForms/vowells/VowellsInformationOnline'
export default function SecondaryStack(Stack: any, params: any) {
  return (
    <>
      <Stack.Screen
        options={{
          title: 'Vowells Acknowledgement - Workhappy',
          headerShown: false
        }}
        name="VowellsInformationForm"
        component={VowellsInformationForm}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'Vowells Acknowledgement Online - Workhappy',
          headerShown: false
        }}
        name="VowellsInformationOnline"
        component={VowellsInformationOnline}
        initialParams={{ ...params }}
      />
      <Stack.Screen
        options={{
          title: 'SM Markets Acknowledgement Online - Workhappy',
          headerShown: false
        }}
        name="SMMarketsAcknowledge"
        component={SMMarketsAcknowledge}
        initialParams={{ ...params }}
      />
    </>
  )
}